import { call, put, takeEvery, select } from 'redux-saga/effects'

import {
	loadingMessage,
	successMessage,
	errorMessage,
} from '~/services/messager'

import api from '~/services/api'

import {
	getDetail,
	getDetailSuccess,
	getDetailFailure,
	listRows,
	listRowsSuccess,
	listRowsFailure,
	deleteRow,
	deleteRowFailure,
	editTitle,
	editTitleSuccess,
	editTitleFailure,
	editRow,
	editRowSuccess,
	editRowFailure,
	createRow,
	createColumn,
	editDatabaseName,
	editDatabaseNameSuccess,
	editDatabaseNameFailure,
	editColumnName,
	editColumnNameSuccess,
	deleteColumn,
	deleteColumnSuccess,
} from '.'

export default function* rootSaga() {
	yield takeEvery(getDetail, getDetailSaga)
	yield takeEvery(listRows, listRowsSaga)
	yield takeEvery(deleteRow, deleteRowSaga)
	yield takeEvery(editTitle, editTitleSaga)
	yield takeEvery(editRow, editRowSaga)
	yield takeEvery(createRow, createRowSaga)
	yield takeEvery(createColumn, createColumnSaga)
	yield takeEvery(editDatabaseName, editDatabaseNameSaga)
	yield takeEvery(editColumnName, editColumnNameSaga)
	yield takeEvery(deleteColumn, deleteColumnSaga)
}

function* getDetailSaga({ payload = {} }) {
	const { id: db_id } = payload
	try {
		const { data } = yield call(api.get, `internaldbs/${db_id}`)

		yield put(getDetailSuccess(data))
	} catch (error) {
		yield put(getDetailFailure(error))
	}
}

function* listRowsSaga({ payload = {} }) {
	const { id: db_id, perPage = 10, page = 1, searchTerm = '' } = payload

	try {
		const { data } = yield call(
			api.get,
			`internaldbs/${db_id}/rows?per_page=${perPage}&page=${page}&search=${searchTerm || ''}`
		)

		yield put(listRowsSuccess({ ...data, id: db_id }))
	} catch (error) {
		yield put(listRowsFailure(error))
	}
}

function* deleteRowSaga({ payload = {} }) {
	loadingMessage({
		content: 'Excluindo linha...',
		updateKey: 'deleteRow',
	})
	const { key: item_id } = payload

	const database = yield select((state) => {
		const { internalDatabaseDetails } = state
		return internalDatabaseDetails.database
	})

	try {
		yield call(api.delete, `internaldbs/rows/${item_id}`)

		successMessage({
			content: 'Linha excluída com sucesso.',
			updateKey: 'deleteRow',
		})

		yield put(listRows({ id: database.id }))
	} catch (error) {
		yield put(deleteRowFailure(error))
		errorMessage({
			content: 'Exclusão da linha falhou.',
			updateKey: 'deleteRow',
		})
	}
}

function* editTitleSaga() {
	loadingMessage({
		content: 'Renomeando banco de dados...',
		updateKey: 'editTitle',
	})

	const database = yield select((state) => {
		const { databaseDetail } = state
		return databaseDetail.database
	})

	try {
		const { patch } = yield call(api.patch, `internaldbs/${database.id}`, {
			title: database.title,
		})

		yield put(editTitleSuccess(patch))
		successMessage({
			content: 'Banco de dados renomeado com sucesso!',
			updateKey: 'editTitle',
		})
	} catch (error) {
		yield put(editTitleFailure(error))
		errorMessage({
			content: 'Falha ao renomear banco de dados',
			updateKey: 'editTitle',
		})
	}
}

function* createRowSaga({ payload = {} }) {
	const { page = 1, perPage = 10 } = payload
	loadingMessage({
		content: 'Criando linha...',
		updateKey: 'createRow',
	})

	const database = yield select((state) => {
		const { internalDatabaseDetails } = state
		return internalDatabaseDetails.database
	})

	try {
		yield call(api.post, `internaldbs/${database.id}/rows`, {
			data: database.structure.map((obj) => ({ column: obj.name, value: '' })),
			key: 'new',
		})

		successMessage({
			content: 'Linha criada com sucesso!',
			updateKey: 'createRow',
		})

		yield put(listRows({ id: database.id, page: page, per_page: perPage }))
	} catch (error) {
		yield put(editRowFailure(error))
		errorMessage({
			content: 'Falha ao criar linha',
			updateKey: 'createRow',
		})
	}
}

function* editRowSaga({ payload = {} }) {
	const {
		id,
		data,
		page = 1,
		perPage = 10,
		searchTerm = '',
		databaseId,
	} = payload
	loadingMessage({
		content: 'Salvando linha...',
		updateKey: 'editedRow',
	})

	const internalDatabaseDetails = yield select((state) => {
		const { internalDatabaseDetails } = state
		return internalDatabaseDetails
	})

	try {
		const response = yield call(api.patch, `internaldbs/rows/${id}`, {
			data: internalDatabaseDetails.database.structure.map((column) => ({
				column: column.name,
				value: data[column.name],
			})),
		})

		yield put(editRowSuccess({ data: response.data }))
		successMessage({
			content: 'Linha salva com sucesso!',
			updateKey: 'editedRow',
		})
		yield put(
			listRows({
				id: databaseId,
				page: page,
				per_page: perPage,
				searchTerm: searchTerm,
			})
		)
	} catch (error) {
		yield put(editRowFailure({ error, previousState: internalDatabaseDetails }))
		errorMessage({
			content: 'Falha ao salvar linha',
			updateKey: 'editedRow',
		})
	}
}

function* createColumnSaga(payload = {}) {
	loadingMessage({
		content: 'Adicionando coluna...',
		updateKey: 'addColumn',
	})

	const { database } = yield select((state) => {
		const { internalDatabaseDetails } = state
		return internalDatabaseDetails
	})

	const { data } = yield call(api.get, `internaldbs/${database.id}`)
	const prev_structure = data.structure

	try {
		yield call(api.patch, `internaldbs/${database.id}`, {
			structure: [...prev_structure, payload.payload],
		})

		// yield put(editRowSuccess())
		successMessage({
			content: 'Nova coluna adicionada com sucesso!',
			updateKey: 'addColumn',
		})

		yield put(listRows({ id: database.id }))
	} catch (error) {
		yield put(editRowFailure(error))
		errorMessage({
			content: 'Falha ao adicionar coluna',
			updateKey: 'addColumn',
		})
	}
}

function* editDatabaseNameSaga() {
	loadingMessage({
		content: 'Renomeando banco de dados...',
		updateKey: 'editDatabaseName',
	})

	const database = yield select((state) => {
		const { internalDatabaseDetails } = state
		return internalDatabaseDetails.database
	})

	try {
		yield call(api.patch, `internaldbs/${database.id}`, {
			name: database.name,
		})

		yield put(editDatabaseNameSuccess())
		successMessage({
			content: 'Banco de dados renomeado com sucesso!',
			updateKey: 'editDatabaseName',
		})
	} catch (error) {
		yield put(editDatabaseNameFailure(error))
		errorMessage({
			content: 'Falha ao renomear banco de dados',
			updateKey: 'editDatabaseName',
		})
	}
}

function* editColumnNameSaga(payload = {}) {
	loadingMessage({
		content: 'Renomeando coluna...',
		updateKey: 'editColumnName',
	})

	const { database } = yield select((state) => {
		const { internalDatabaseDetails } = state
		return internalDatabaseDetails
	})

	try {
		const response = yield call(
			api.patch,
			`internaldbs/${database.id}/columns`,
			{
				old_name: payload.payload.old_name,
				new_name: payload.payload.new_name,
			}
		)
		const { internal_db, rows } = response.data
		yield put(
			editColumnNameSuccess({ structure: internal_db.structure, rows: rows })
		)
		successMessage({
			content: 'Coluna renomeada com sucesso!',
			updateKey: 'editColumnName',
		})
	} catch (error) {
		yield put(editRowFailure(error))
		errorMessage({
			content: 'Falha ao renomear coluna',
			updateKey: 'editColumnName',
		})
	}
}

function* deleteColumnSaga(payload = {}) {
	loadingMessage({
		content: 'Removendo coluna...',
		updateKey: 'deleteColumn',
	})

	const { database } = yield select((state) => {
		const { internalDatabaseDetails } = state
		return internalDatabaseDetails
	})

	try {
		const response = yield call(
			api.delete,
			`internaldbs/${database.id}/columns`,
			{
				data: {
					column_name: payload.payload,
				},
			}
		)
		const { internal_db, rows } = response.data
		yield put(
			deleteColumnSuccess({ structure: internal_db.structure, rows: rows })
		)
		successMessage({
			content: 'Coluna removida com sucesso!',
			updateKey: 'deleteColumn',
		})
	} catch (error) {
		yield put(editRowFailure(error))
		errorMessage({
			content: 'Falha ao remover coluna',
			updateKey: 'deleteColumn',
		})
	}
}
